import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CondicionesComponent} from "../../condiciones.component";
import {ConditionService} from "../../../../../../core/services/parameters/condition.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-condition.component.html',
  styleUrls: ['./confirm-delete-condition.component.scss']
})
export class ConfirmDeleteConditionComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<CondicionesComponent>,
    private conditionService: ConditionService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.conditionService.deleteCondition(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      })
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
